module.exports = __webpack_public_path__ + "static/media/front.a2e8c075.jpg";